import {Component, computed, inject, input} from '@angular/core';
import {UserModel} from '@core/api/data-access';
import {TranslateModule} from '@ngx-translate/core';
import {IconComponent} from '@shared/icon';
import {UserFormChangesService} from '../../../services/user-form-changes.service';

@Component({
	selector: 'dc-form-changes-indicator',
	imports: [TranslateModule, IconComponent],
	template: `
		@if (showChanges()) {
			<div class="form-changes" [class.form-changes--expanded]="isExpanded()">
				<div class="form-changes__header" (click)="toggleExpand()" (keydown.enter)="toggleExpand()" (keydown.space)="toggleExpand()" tabindex="0" role="button" [attr.aria-expanded]="isExpanded()">
					<div class="form-changes__title">
						<icon icon="fa-solid fa-clock-rotate-left" class="mr-2"></icon>
						<span>{{ 'user.form.changes.title' | translate }}</span>
						<span class="form-changes__count ml-2">({{ changesCount() }})</span>
					</div>
					<div class="form-changes__toggle">
						<icon [icon]="isExpanded() ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></icon>
					</div>
				</div>

				@if (isExpanded()) {
					<div class="form-changes__list">
						@for (change of changes(); track change.field) {
							<div class="change-item">
								<div class="change-item__field">{{ 'user.form.field.' + change.field | translate }}</div>
								<div class="change-item__values">
									<div class="change-item__original">
										<span class="change-item__original__label">{{ 'user.form.changes.original' | translate }}:</span>
										@let originalValue = change.originalValue !== null && change.originalValue !== undefined ? change.originalValue.toString() : 'user.form.changes.empty';
										<span class="change-item__original__text">{{ originalValue | translate }}</span>
									</div>
									<div class="change-item__new">
										<span class="change-item__new__label">{{ 'user.form.changes.new' | translate }}:</span>
										@let newValue = change.newValue !== null && change.newValue !== undefined ? change.newValue.toString() : 'user.form.changes.empty';
										<span class="change-item__new__text">{{ newValue | translate }}</span>
									</div>
								</div>
							</div>
						}
					</div>
				}
			</div>
		}
	`,
	styleUrls: ['./form-changes-indicator.component.scss'],
})
export class FormChangesIndicatorComponent {
	private readonly changesService = inject(UserFormChangesService);

	// Inputs
	public readonly originalUser = input<UserModel | null>(null);
	public readonly enabled = input<boolean>(true);

	// Signals
	public readonly changes = computed(() => this.changesService.fieldChanges());
	public readonly changesCount = computed(() => this.changes().length);
	public readonly showChanges = computed(() => this.enabled() && this.changesCount() > 0);
	public readonly isExpanded = this.changesService.isExpanded;

	// Methods
	public toggleExpand(): void {
		this.changesService.toggleExpanded();
	}
}
